<optima-off-canvas [id]="id" [placement]="placement" [level]="level">
  <button cButtonClose slot="header" class="text-reset" (click)="onCloseButtonClicked()" aria-label="Close"></button>
  <ng-container slot="body">
    @if(id | offcanvasLevelCheck : level : offCanvasFormService.currentHighestLevel){
    @if( level | formSelector: offCanvasFormService: offCanvasComponents.AddDashboard){
    <app-form-add-dashboard></app-form-add-dashboard>
    }
    @if( level | formSelector: offCanvasFormService: offCanvasComponents.AddLibraryFolder){
    <app-form-add-library-folder></app-form-add-library-folder>
    }

    @if( level | formSelector: offCanvasFormService: offCanvasComponents.AddFolder){
    <app-form-add-folder></app-form-add-folder>
    }

    @if( level | formSelector: offCanvasFormService: offCanvasComponents.SaveAsTemplate){
    <app-form-save-as-template></app-form-save-as-template>
    }

    @if( level | formSelector: offCanvasFormService: offCanvasComponents.AddFile){
    <app-form-add-file></app-form-add-file>
    }

    @if( level | formSelector: offCanvasFormService: offCanvasComponents.UpdateLibraryFolder){
    <app-form-update-library-folder></app-form-update-library-folder>
    }

    @if(shouldRenderComponent(LibFormBizEntityComponent)){
      <app-form-biz-entity [bizEntity]="bizEntity" [isEditing]="isEditing" [excludeParentAndOwner]="shouldExcludeParentAndOwner()"
        (saveComplete)="onBizEntitySaveComplete($event)"></app-form-biz-entity>
      }
 @if(shouldRenderComponent(LibFormBizEntityTypeComponent)){
      <app-form-biz-entity-type [isEditing]="isEditing" [editBizEntityType]="bizEntityTypeForEdit"></app-form-biz-entity-type>
      }

    } @else if(renderErrors) {
    <div style="height:200px;flex:1;background-color: darkorange; color:white; padding:1rem">
      <h1>Render Failed</h1>
      <p>OffCanvas is being tried to open directly instead of new method!</p>
    </div>
    }
  </ng-container>
</optima-off-canvas>